export default class SourceSerializer {
  static serialize(data) {
    return {
      descr: data.descr
    };
  }

  static deSerialize(data) {
    return {
      descr: data.descr
    };
  }
}